module.exports = __webpack_public_path__ + "school/img/kecb.7ec10046.jpg";